"use client";

import { useEffect, useState } from "react";

// Recomputes from the end timestamp on every tick, rather than decrementing a
// local counter — a throttled/backgrounded tab can only delay a tick, never
// bring one early, so a naive decrement can only fall behind the real
// deadline and then jump straight to expired once something resyncs it.
const useCountdownSeconds = (timeRemains?: number) => {
  const [secondsLeft, setSecondsLeft] = useState(timeRemains ?? 0);

  useEffect(() => {
    setSecondsLeft(timeRemains ?? 0);

    if (!timeRemains) return;

    const endAt = Date.now() + timeRemains * 1000;
    const interval = setInterval(() => {
      setSecondsLeft(Math.max(0, Math.round((endAt - Date.now()) / 1000)));
    }, 1000);

    return () => clearInterval(interval);
  }, [timeRemains]);

  return secondsLeft;
};

export default useCountdownSeconds;
